import { ApplyForm, PoolForm } from "@interfaces/career"
import FormRepositories from "../repositories/form.repositories"
import { Result } from "./result"

export default class FormServices extends FormRepositories {
  async postFormApply(body: ApplyForm) {
    try {
      const res = await this.storeFormApply(body)
      const response = await this._getResponse<any>(res)
      const { error, result } = response
      if (error) {
        return Result.fail<any>()
      }
      return Result.ok<any>(result)
    } catch (e: any) {
      console.log(e)
      return Result.fail<any>()
    }
  }

  async postFormPool(body: PoolForm) {
    try {
      const res = await this.storeFormPool(body)
      const response = await this._getResponse<any>(res)
      const { error, result } = response
      if (error) {
        return Result.fail<any>()
      }
      return Result.ok<any>(result)
    } catch (e: any) {
      console.log(e)
      return Result.fail<any>()
    }
  }

  async postAssetForm(body: any) {
    try {
      const res = await this.storeAssetForm(body)
      const response = await this._getResponse<any>(res)
      const { error, result } = response
      if (error) {
        return Result.fail<any>()
      }
      return Result.ok<any>(result)
    } catch (e: any) {
      console.log(e)
      return Result.fail<any>()
    }
  }
}
